{
  "version": 1,
  "asset_id": "9061a41f-e8fd-4999-9783-9fafa9b59eaf",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/9061a41f-e8fd-4999-9783-9fafa9b59eaf/dona-maria.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/9061a41f-e8fd-4999-9783-9fafa9b59eaf/dona-maria.webp",
  "original_filename": "dona-maria.webp",
  "size": 59636,
  "content_type": "image/webp",
  "created_at": "2026-07-21T20:12:24Z"
}
